import * as React from "react";
import { Box } from "@mui/material";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minWidth?: number | { xs: string; sm: number; md: number };
  onIconClick?: () => void;
}

export default function SearchInput({ value, onChange, placeholder = "Search...", minWidth = 260, onIconClick }: SearchInputProps) {
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <Box sx={{ minWidth: typeof minWidth === "object" ? minWidth : minWidth }}>
      <Box
        sx={{ display: "flex", alignItems: "center", padding: "6px 12px", border: isFocused ? "1px solid #212529" : "1px solid #d1d5db", borderRadius: "6px", backgroundColor: "#ffffff", transition: "border-color 0.2s" }}
      >
        <span style={{ fontSize: "1rem", color: "#6b7280", marginRight: "8px", cursor: onIconClick ? "pointer" : "default" }} onClick={onIconClick}>🔍</span>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{ flex: 1, border: "none", outline: "none", fontSize: "0.875rem", color: "#212529", background: "transparent" }}
        />
      </Box>
    </Box>
  );
}
